/**
 * The CleanPlate brand mark: a top-down plate (rim + well) with a small
 * 4-point sparkle inside. Uses currentColor so it inherits the surrounding
 * text color — works inside the terracotta header pill, on the basil-tinted
 * landing feature card, and anywhere else we want the brand glyph.
 *
 * Sized via className like a Lucide icon (e.g. `className="h-5 w-5"`).
 */
type Props = {
  className?: string;
  /** Optional accessible label. Defaults to decorative (aria-hidden). */
  title?: string;
};

export const PlateMark = ({ className, title }: Props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    className={className}
    role={title ? "img" : undefined}
    aria-hidden={title ? undefined : true}
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    <circle cx="16" cy="16" r="11" strokeWidth="2.25" />
    <circle cx="16" cy="16" r="7" strokeWidth="1.5" />
    <path
      d="M16 11.5 L17 15 L20.5 16 L17 17 L16 20.5 L15 17 L11.5 16 L15 15 Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);
